import AbspracheOverviewViewTypes from "./AbspracheOverviewViewTypes";

export const useAbspracheOverviewViewModel = (props: AbspracheOverviewViewTypes.Props) => {
  return { absprachen: props.absprachen };
};
